<template>
  <a-drawer
    :title="$t('敏感内容日志.日志详情')"
    :width="700"
    :visible="visible"
    :closable="true"
    @close="onClose"
  >
    <a-spin :spinning="loading">
      <a-descriptions :column="2" bordered>
        <a-descriptions-item :label="$t('敏感内容日志.用户ID')">
          {{ detail.userId }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('敏感内容日志.用户IP')">
          {{ detail.ip || '-' }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('敏感内容日志.昵称')">
          {{ detail.nickName || '-' }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('敏感内容日志.手机号')">
          {{ detail.mobile || '-' }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('敏感内容日志.业务场景')">
          {{ detail.bizType }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('敏感内容日志.命中类型')">
          <a-tag :color="detail.hitType === 1 ? 'orange' : 'red'">
            {{ detail.hitType === 1 ? $t('敏感内容日志.文本') : $t('敏感内容日志.图片') }}
          </a-tag>
        </a-descriptions-item>

        <a-descriptions-item :label="$t('敏感内容日志.敏感文字内容')" :span="2" v-if="detail.hitType === 1">
          {{ detail.content || '-' }}
        </a-descriptions-item>

        <a-descriptions-item :label="$t('敏感内容日志.违规图片')" :span="2" v-if="detail.hitType === 2">
          <template v-if="detail.imageUrl">
            <a-avatar :size="120" :src="detail.imageUrl" shape="square" @click.native="handleImagePreview(detail.imageUrl)" style="cursor: pointer;" />
          </template>
          <span v-else>-</span>
        </a-descriptions-item>

        <a-descriptions-item :label="$t('敏感内容日志.创建时间')" :span="2">
          {{ parseTime(detail.createTime) }}
        </a-descriptions-item>
      </a-descriptions>
    </a-spin>
  </a-drawer>
</template>

<script>
import { getSensitiveLog } from '@/api/user/sensitiveLog'

export default {
  name: 'DetailForm',
  data() {
    return {
      visible: false,
      loading: false,
      detail: {}
    }
  },
  methods: {
    show(id) {
      this.visible = true
      this.loading = true
      getSensitiveLog(id).then(response => {
        this.detail = response.data
        this.loading = false
      })
    },
    onClose() {
      this.visible = false
    },
    handleImagePreview(url) {
      this.$info({
        title: this.$t('敏感内容日志.图片预览'),
        content: (h) => h('img', { attrs: { src: url, style: 'max-width: 100%; max-height: 400px;' } }),
        width: 600,
        okText: this.$t('通用.按钮.关闭')
      })
    }
  }
}
</script>
